/**
 * Change-password handler
 *
 * Allows an authenticated user to change their own password.
 *
 * Endpoint: PUT /changePassword
 */
import { putMethod } from "./rest-handler";

/**
 * Sends a change-password request for the currently logged-in user.
 *
 * @param oldPassword - The user's current password (plain text; transmitted over HTTPS).
 * @param newPassword - The desired new password.
 * @returns A Promise that resolves on success, or rejects with the error on failure.
 */
export const changePassword = (oldPassword: string, newPassword: string) => {
  return new Promise<void>((resolve, reject) => {
    putMethod("/changePassword", JSON.stringify({ oldPassword, newPassword }))
      .then((response) => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};
